Postlogin = (function (my) {
    my.Reports = {};
    const me = my.Reports;
    me.$reportResultsTable = $('#report-results-table');
    me.currentReport = 'UserOverviewReport';

    me.init = function () {
        me.initEvents();
        $('#report-select').trigger('change');
    };

    // Event Setup
    me.initEvents = function () {
        $('a[data-toggle="tab"].overview-tab').one('shown.bs.tab', () => {
            const overview = Postlogin.OverviewReport;
            overview.init();
        });

        $('a[data-toggle="tab"].licenses-tab').one('shown.bs.tab', () => {
            const licenses = Postlogin.LicensesReport;
            licenses.init();
        });

        $('#report-select').on('change', (event) => {
            event.preventDefault();

            me.currentReport = $(event.currentTarget).val();
            const report = Postlogin[me.currentReport];
            report.setup();
        });

        $('#report-form').on('submit', (event) => {
            event.preventDefault();
            const report = Postlogin[me.currentReport];
            report.runReport();
        });

        // Ported from bootstrap-select to Tom Select 2026-05-11.
        const userLicenseIds = document.getElementById('user-license-ids');
        if (userLicenseIds && userLicenseIds.tagName === 'SELECT') {
            // eslint-disable-next-line no-new
            new TomSelect(userLicenseIds, {
                placeholder: 'All licenses selected',
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        }

        const currentDate = new Date(new Date().setHours(23, 59, 59));
        const dateOptions = {
            restrictions: {
                maxDate: currentDate,
            },
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
        };
        new tempusDominus.TempusDominus(document.getElementById('search-start-date'), {
            ...dateOptions,
            container: document.getElementById('start-date-container'),
        });

        new tempusDominus.TempusDominus(document.getElementById('search-end-date'), {
            ...dateOptions,
            container: document.getElementById('end-date-container'),
        });

        $('#report-form').on('change', '#search-date', () => {
            const value = $('#search-date option:selected').val();
            if (value === 'custom') {
                $('#search-start-date').val(moment().subtract(14, 'days').format('L'));
                $('#search-end-date').val(moment().format('L'));

                $('#report-form .date-container.hide').removeClass('hide');
            } else {
                $('#report-form .date-container').addClass('hide');
            }
        });

        // Ported from bootstrap-select to Tom Select 2026-05-11.
        // bootstrap-select needed .val('').selectpicker('render') to
        // clear both the native <select> AND its rendered chrome.
        // Tom Select exposes the live instance via el.tomselect; its
        // .clear() method wipes both the underlying <select>.value and
        // the rendered chips in one call. For <select>s that were
        // never wrapped by Tom Select on this page the element won't
        // have .tomselect, so we fall back to the native .val('').
        const clearSelect = (selector) => {
            const el = document.querySelector(selector);
            if (!el) return;
            if (el.tomselect) {
                el.tomselect.clear();
            } else {
                $(el).val('');
            }
        };

        $('#report-select').on('change', () => {
            // clear all values when switching.
            clearSelect('#user-types');
            clearSelect('#user-groups');
            clearSelect('#user-groups-single');
            clearSelect('#user-grades');
            $('#search-active').val('both');
            $('#search-user-name').val('');
            $('#search-unique-identifier').val('');
            $('#subtitle').val('');
            $('#assigned-by').val('');
            clearSelect('#lessons');
            $('#completion-status').val('');
            $('#search-first-name').val('');
            $('#search-last-name').val('');

            // Not changing this one right now.
            // $('#search-date').val('');
        });

        $('#report-export').on('click', (event) => {
            event.preventDefault();

            const report = Postlogin[me.currentReport];
            report.exportReport();
        });
    };

    // Base Table Options
    me.tableOptions = _.extend({}, Jr.dataTable.options, {
        formatNoMatches() {
            return 'No users to show';
        },
        contentType: 'application/x-www-form-urlencoded',
        classes: 'table table-hover table-condensed',
        height: window.innerHeight * 0.85,
        striped: true,
        showRefresh: true,
        showToggle: false,
        showColumns: true,
        showPaginationSwitch: false,
        minimumCountColumns: '2',
        pagination: true,
        search: false,
        toolbarAlign: 'right',
        searchAlign: 'left',
        clickToSelect: true,
        maintainSelected: false,
        sidePagination: 'server',
        pageSize: 25,

        onLoadSuccess(data) {
            $('time.timeago').timeago();
            me.$reportResultsTable.removeClass('sorting');
            me.$reportResultsTable.closest('.bootstrap-table').find('.pagination-detail .duration').remove();
            me.$reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(`<span class="duration">&nbsp;&nbsp;<em>(query took ${data.duration.toFixed(4)} seconds)</em></span>`);

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();
        },
        onSort() {
            // when sorting, grey out the table contents until the results are back
            me.$reportResultsTable.addClass('sorting');
            $('body').css('cursor', 'progress');
        },
        onColumnSwitch() {
            if ($('#search-date option:selected').val() === 'custom') {
                $('#report-results-table th.date-range-header').text(`${$('#search-start-date').val()} to ${$('#search-end-date').val()}`);
            } else {
                $('#report-results-table th.date-range-header').text($('#search-date option:selected').text());
            }
        },
    });

    return my;
}(Postlogin));
